/* eslint-disable react-hooks/exhaustive-deps */
import { matchSorter } from 'match-sorter';
import { useState, useEffect, useRef } from 'react';
var ESC_KEY = 'Escape';
var OPEN_DROPDOWN_KEYS = ['Enter', 'ArrowUp', 'ArrowDown'];

var useDropdown = (options, disabled, isSearchable, value, onChangeOption) => {
  var getValue = () => options.find(option => option.value === value);

  var initialOption = {
    value: '',
    text: ''
  };
  var [hasSelectedValue, setHasSelectedValue] = useState(false);
  var [selectedValue, setSelectedValue] = useState(initialOption);
  var [toggleOptions, setToggleOptions] = useState(false);
  var [searchValue, setSearchValue] = useState('');
  var containerRef = useRef(null);
  var inputSearchRef = useRef(null);

  var handleKeydown = event => {
    if (containerRef.current === document.activeElement) {
      var {
        code: key
      } = event;

      if (ESC_KEY === key) {
        setToggleOptions(false);
        return;
      }

      if (OPEN_DROPDOWN_KEYS.includes(key)) {
        setToggleOptions(true);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);
  useEffect(() => {
    if (!isSearchable || !inputSearchRef.current) return;

    if (toggleOptions) {
      var _inputSearchRef$curre;

      (_inputSearchRef$curre = inputSearchRef.current) === null || _inputSearchRef$curre === void 0 ? void 0 : _inputSearchRef$curre.focus();
      inputSearchRef.current.value = selectedValue.text;
    } else {
      setSearchValue('');
      inputSearchRef.current.value = '';
    }
  }, [isSearchable, toggleOptions, inputSearchRef]);
  useEffect(() => {
    if (value) {
      var _initialOption = getValue();

      if (_initialOption) {
        setHasSelectedValue(true);
        setSelectedValue(_initialOption);
      }
    } else {
      setHasSelectedValue(false);
      setSelectedValue(initialOption);
    }
  }, [value]);

  var getOptions = filter => {
    var _matchSorter;

    return (_matchSorter = matchSorter(options, filter, {
      keys: ['text']
    })) !== null && _matchSorter !== void 0 ? _matchSorter : [];
  };

  var onSelectOption = item => {
    setSelectedValue(item);
    setHasSelectedValue(true);
    setToggleOptions(false);
    onChangeOption(item);
  };

  var toggleOptionsContainer = () => {
    if (!disabled) setToggleOptions(!toggleOptions);
  };

  var handleOutsideClick = () => {
    setToggleOptions(false);
  };

  var handleSearchChange = event => {
    setSearchValue(event.currentTarget.value);
  };

  return {
    hasSelectedValue,
    selectedValue,
    toggleOptions,
    containerRef,
    inputSearchRef,
    searchValue,
    toggleOptionsContainer,
    onSelectOption,
    getOptions,
    handleOutsideClick,
    handleSearchChange
  };
};

export { useDropdown };
//# sourceMappingURL=useDropdown.js.map